import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { API_ENDPOINTS } from "../../../api/endpoints";
import Select from "react-select";

const TarifasClientesFormModal = ({ visible, onClose, onSuccess, tarifaClientesParaEditar, listaClientes = [], listaTarifas = [] }) => {
  const [clienteId, setClienteId] = useState("");
  const [tarifaId, setTarifaId] = useState("");
  const [estado, setEstado] = useState(1);

  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [exito, setExito] = useState(false);
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const [eliminando, setEliminando] = useState(false);
  const [eliminadoOk, setEliminadoOk] = useState(false);

  const options = listaTarifas.map((t) => ({
    value: t.id,
    label: t.tipo_movil,
  }));

  useEffect(() => {
    if (tarifaClientesParaEditar) {
      setClienteId(tarifaClientesParaEditar.cliente_id || "");
      setTarifaId(tarifaClientesParaEditar.tarifa_id || "");
      setEstado(tarifaClientesParaEditar.estado !== undefined ? tarifaClientesParaEditar.estado : 1);
    } else {
      setClienteId("");
      setTarifaId("");
      setEstado(1);
    }
    setError(null);
    setExito(false);
    setMostrarConfirmacion(false);
    setEliminando(false);
    setEliminadoOk(false);
  }, [tarifaClientesParaEditar, visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError(null);
    setExito(false);
    const username = Cookies.get("userName");

    try {
      const endpoint = tarifaClientesParaEditar ? API_ENDPOINTS.interna.UpdateDataTarifaClient : API_ENDPOINTS.interna.InsertDataTarifaClient;

      const bodyData = {
        cliente_id: clienteId,
        tarifa_id: tarifaId,
        estado: estado,
        username,
      };

      if (tarifaClientesParaEditar) {
        bodyData.id = tarifaClientesParaEditar.id;
      }

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyData),
      });

      const result = await res.json();
      if (!res.ok || result.error) throw new Error(result.error || "Error al guardar tarifa");

      setExito(true);
      setTimeout(() => {
        setExito(false);
        onSuccess?.();
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.message || "Error al guardar tarifa");
    } finally {
      setCargando(false);
    }
  };

  const handleEliminarTarifaClient = async () => {
    setEliminando(true);
    const username = Cookies.get("userName");

    try {
      const res = await fetch(API_ENDPOINTS.interna.DeleteDataTarifaClient, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: tarifaClientesParaEditar.id,
          username,
        }),
      });

      const result = await res.json();
      if (!res.ok || result.error) throw new Error(result.error || "Error al eliminar tarifa");

      setEliminadoOk(true);
      setTimeout(() => {
        setEliminadoOk(false);
        onSuccess?.();
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.message || "Error al eliminar tarifa");
    } finally {
      setEliminando(false);
      setMostrarConfirmacion(false);
    }
  };

  if (!visible) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow-lg">
            <div className="modal-header">
              <h5 className="modal-title">{tarifaClientesParaEditar ? "Editar asignación" : "Nueva asignación"}</h5>
              <button className="btn-close" onClick={onClose} disabled={cargando || exito}></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}
                {exito && (
                  <div className="alert alert-success text-center position-absolute top-50 start-50 translate-middle w-75 shadow">✅ Tarifa {tarifaClientesParaEditar ? "actualizada" : "insertada"} correctamente.</div>
                )}
                {eliminadoOk && <div className="alert alert-success text-center position-absolute top-50 start-50 translate-middle w-75 shadow">🗑️ Tarifa eliminada correctamente.</div>}
                <fieldset disabled={cargando || exito || eliminadoOk}>
                  <div className="mb-3">
                    <label className="form-label">Cliente</label>
                    <select className="form-select" value={clienteId} onChange={(e) => setClienteId(e.target.value)} required>
                      <option value="">Seleccione...</option>
                      {listaClientes.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Tarifa</label>
                    <select className="form-select" value={tarifaId} onChange={(e) => setTarifaId(e.target.value)} required>
                      <option value="">Seleccione...</option>
                      {listaTarifas.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.tipo_movil}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Estado</label>
                    <select className="form-select" value={estado} onChange={(e) => setEstado(parseInt(e.target.value))}>
                      <option value={1}>Activo</option>
                      <option value={0}>Inactivo</option>
                    </select>
                  </div>
                </fieldset>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={cargando || exito || eliminadoOk}>
                  Cancelar
                </button>

                {tarifaClientesParaEditar && (
                  <button type="button" className="btn btn-outline-danger" onClick={() => setMostrarConfirmacion(true)} disabled={cargando || eliminando || eliminadoOk}>
                    {eliminando ? "Eliminando..." : "Eliminar"}
                  </button>
                )}

                <button type="submit" className="btn btn-primary" disabled={cargando || exito || eliminadoOk}>
                  {cargando ? "Guardando..." : "Guardar"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal de confirmación para eliminar */}
      {mostrarConfirmacion && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title">Confirmar eliminación</h5>
              </div>
              <div className="modal-body">
                <p>¿Estás seguro de que deseas eliminar esta tarifa?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setMostrarConfirmacion(false)} disabled={eliminando}>
                  Cancelar
                </button>
                <button className="btn btn-danger" onClick={handleEliminarTarifaClient} disabled={eliminando}>
                  {eliminando ? "Eliminando..." : "Eliminar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TarifasClientesFormModal;
